/* eslint-disable no-unused-vars */

import { v4 as uuidv4 } from 'uuid';

export const prepareNewAndEditedEquipmentForBackend = ({
  asset,
  equipmentFormsUserCacheMap,
  jurisdictionNumbersMap
}) => {
  const fieldSourcePropertyWIthValue = getDataFromObjects({
    data: asset,
    equipmentFormsUserCacheMap
  });
  // console.log({ fieldSourcePropertyWIthValue });
  const { jurisdictionNumber, jurisdiction } = jurisdictionNumbersMap[asset.equipmentId] || {};

  const mapEquipmentObjects = {
    ...(!asset?.isNew && asset?.equipmentId && { reconciliationRecordId: uuidv4() }),
    // ...(!asset?.isNew &&
    //   asset?.equipmentNumber && { reconciliationRecordNumber: asset?.equipmentNumber }),
    ...(!asset?.isNew && asset?.equipmentId && { equipmentId: asset?.equipmentId }),

    ...(asset?.isNew && asset?.equipmentId && { ondemandid: asset?.equipmentId }),

    ...(asset?.siteId && { siteId: asset?.siteId }),
    ...(asset?.name && { name: asset?.name }),
    ...(asset?.status && { status: asset?.status }),
    ...(asset?.equipmentCategory && { categoryId: asset?.equipmentCategory }),
    ...(asset?.equipmentType && { equipmentType: asset?.equipmentType }),
    ...(asset?.equipmentSubType && { equipmentSubType: asset?.equipmentSubType }),
    ...(asset?.description && { description: asset?.description }),
    ...(asset?.manufacturer && { manufacturer: asset?.manufacturer }),
    ...(asset?.model && { model: asset?.model }),
    ...(asset?.physicalLocation && { physicalLocation: asset?.physicalLocation }),
    ...(asset?.serialNumber && { serialNumber: asset?.serialNumber }),
    ...(asset?.fieldTagNumber && { fieldTagNumber: asset?.fieldTagNumber }),
    ...(asset?.manufacturedYear && { manufacturedYear: parseInt(asset?.manufacturedYear) }),
    ...(asset?.commentForReviewer && { comments: asset?.commentForReviewer }),
    ...(fieldSourcePropertyWIthValue?.flangeInletSize?.textBoxValue && {
      inletSize: fieldSourcePropertyWIthValue?.flangeInletSize?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.flangeInletSize?.textBoxUnitValue && {
      inletSizeMeasurement: fieldSourcePropertyWIthValue?.flangeInletSize?.textBoxUnitValue
    }),
    ...(fieldSourcePropertyWIthValue?.flangeOutletSize?.textBoxValue && {
      outletSize: fieldSourcePropertyWIthValue?.flangeOutletSize?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.flangeOutletSize?.textBoxUnitValue && {
      outletSizeMeasurement: fieldSourcePropertyWIthValue?.flangeOutletSize?.textBoxUnitValue
    }),
    ...(fieldSourcePropertyWIthValue?.cRN_Number && {
      crnNumber: fieldSourcePropertyWIthValue?.cRN_Number
    }),
    ...(fieldSourcePropertyWIthValue?.pressure?.textBoxValue && {
      pressure: fieldSourcePropertyWIthValue?.pressure?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.pressure?.textBoxUnitValue && {
      pressureUnit: fieldSourcePropertyWIthValue?.pressure?.textBoxUnitValue
    }),
    ...(fieldSourcePropertyWIthValue?.pSVCapacity?.textBoxValue && {
      psvCapacity: fieldSourcePropertyWIthValue?.pSVCapacity?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.pSVCapacity?.textBoxUnitValue && {
      psvCapacityUnit: fieldSourcePropertyWIthValue?.pSVCapacity?.textBoxUnitValue
    }),

    ...(fieldSourcePropertyWIthValue?.assessedCondition && {
      assessedCondition: fieldSourcePropertyWIthValue?.assessedCondition
    }),
    ...(fieldSourcePropertyWIthValue?.condition && {
      condition: fieldSourcePropertyWIthValue?.condition
    }),
    ...(fieldSourcePropertyWIthValue?.code_Of_Construction && {
      codeOfConstruction: fieldSourcePropertyWIthValue?.code_Of_Construction
    }),

    ...(fieldSourcePropertyWIthValue?.cylinderDate && {
      cylinderDate: fieldSourcePropertyWIthValue?.cylinderDate
    }),
    ...(fieldSourcePropertyWIthValue?.cylinderExpiryDate && {
      cylinderExpiryDate: fieldSourcePropertyWIthValue?.cylinderExpiryDate
    }),
    ...(fieldSourcePropertyWIthValue?.cylinderSerialNum && {
      cylinderSerialNum: fieldSourcePropertyWIthValue?.cylinderSerialNum
    }),

    ...(fieldSourcePropertyWIthValue?.cylinderType && {
      cylinderType: fieldSourcePropertyWIthValue?.cylinderType
    }),

    ...(fieldSourcePropertyWIthValue?.diameter?.textBoxValue && {
      diameter: fieldSourcePropertyWIthValue?.diameter?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.diameter?.textBoxUnitValue && {
      diameterMeasurement: fieldSourcePropertyWIthValue?.diameter?.textBoxUnitValue
    }),

    ...(fieldSourcePropertyWIthValue?.gearboxManufacturer && {
      gearboxManufacturer: fieldSourcePropertyWIthValue?.gearboxManufacturer
    }),

    ...(fieldSourcePropertyWIthValue?.gearboxRate && {
      gearboxRate: fieldSourcePropertyWIthValue?.gearboxRate
    }),

    ...(fieldSourcePropertyWIthValue?.gearboxSerialNumber && {
      gearboxSerialNumber: fieldSourcePropertyWIthValue?.gearboxSerialNumber
    }),

    ...(fieldSourcePropertyWIthValue?.head2Thickness?.textBoxValue && {
      head2Thickness: fieldSourcePropertyWIthValue?.head2Thickness?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.head2Thickness?.textBoxUnitValue && {
      head2Thickness_Measurement: fieldSourcePropertyWIthValue?.head2Thickness?.textBoxUnitValue
    }),

    ...(fieldSourcePropertyWIthValue?.headMaterialId && {
      headMaterialId: fieldSourcePropertyWIthValue?.headMaterialId
    }),

    ...(fieldSourcePropertyWIthValue?.headThickness?.textBoxValue && {
      headThickness: fieldSourcePropertyWIthValue?.headThickness?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.headThickness?.textBoxUnitValue && {
      headThickness_Measurement: fieldSourcePropertyWIthValue?.headThickness?.textBoxUnitValue
    }),

    ...(fieldSourcePropertyWIthValue?.hydrotestExpiryDate5Year && {
      hydrotestExpiryDate5Year: fieldSourcePropertyWIthValue?.hydrotestExpiryDate5Year
    }),

    ...(fieldSourcePropertyWIthValue?.insulationMaterialId && {
      insulationMaterialId: fieldSourcePropertyWIthValue?.insulationMaterialId
    }),

    ...(fieldSourcePropertyWIthValue?.lastMainStationRegInspDate && {
      lastMainStationRegInspDate: fieldSourcePropertyWIthValue?.lastMainStationRegInspDate
    }),
    ...(fieldSourcePropertyWIthValue?.lastSuppliedAirHarnessRegInspDate && {
      lastSuppliedAirHarnessRegInspDate:
        fieldSourcePropertyWIthValue?.lastSuppliedAirHarnessRegInspDate
    }),

    ...(fieldSourcePropertyWIthValue?.length?.textBoxValue && {
      length: fieldSourcePropertyWIthValue?.length?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.length?.textBoxUnitValue && {
      length_Measurement: fieldSourcePropertyWIthValue?.length?.textBoxUnitValue
    }),

    ...(fieldSourcePropertyWIthValue?.mAWP?.textBoxValue && {
      mawp: fieldSourcePropertyWIthValue?.mAWP?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.mAWP?.textBoxUnitValue && {
      mawp_Measurement: fieldSourcePropertyWIthValue?.mAWP?.textBoxUnitValue
    }),

    ...(fieldSourcePropertyWIthValue?.mAWT?.textBoxValue && {
      mawt: fieldSourcePropertyWIthValue?.mAWT?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.mAWT?.textBoxUnitValue && {
      mawt_Measurement: fieldSourcePropertyWIthValue?.mAWT?.textBoxUnitValue
    }),

    ...(fieldSourcePropertyWIthValue?.mDMT?.textBoxValue && {
      mdmt: fieldSourcePropertyWIthValue?.mDMT?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.mDMT?.textBoxUnitValue && {
      mdmt_Measurement: fieldSourcePropertyWIthValue?.mDMT?.textBoxUnitValue
    }),

    ...(fieldSourcePropertyWIthValue?.orientation && {
      orientation: fieldSourcePropertyWIthValue?.orientation
    }),

    ...(fieldSourcePropertyWIthValue?.outsideDiameter?.textBoxValue && {
      outsideDiameter: fieldSourcePropertyWIthValue?.outsideDiameter?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.outsideDiameter?.textBoxUnitValue && {
      outsideDiameter_Measurement: fieldSourcePropertyWIthValue?.outsideDiameter?.textBoxUnitValue
    }),

    ...(fieldSourcePropertyWIthValue?.plateNumber && {
      plateNumber: parseInt(fieldSourcePropertyWIthValue?.plateNumber)
    }),

    ...(fieldSourcePropertyWIthValue?.pSVCapacity?.textBoxUnitValue && {
      PSVCapacity_Measurement: fieldSourcePropertyWIthValue?.pSVCapacity?.textBoxUnitValue
    }),

    ...(fieldSourcePropertyWIthValue?.service && {
      service: fieldSourcePropertyWIthValue?.service
    }),

    ...(fieldSourcePropertyWIthValue?.setPointPressure?.textBoxValue && {
      setPointPressure: fieldSourcePropertyWIthValue?.setPointPressure?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.setPointPressure?.textBoxUnitValue && {
      setPointPressure_Measurement: fieldSourcePropertyWIthValue?.setPointPressure?.textBoxUnitValue
    }),

    ...(fieldSourcePropertyWIthValue?.shellMaterialId && {
      shellMaterialId: fieldSourcePropertyWIthValue?.shellMaterialId
    }),
    ...(asset?.manufacturedYear && { yearBuilt: parseInt(asset?.manufacturedYear) }),
    ...(fieldSourcePropertyWIthValue?.shellSideMAWP?.textBoxValue && {
      shellSideMAWP: fieldSourcePropertyWIthValue?.shellSideMAWP?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.shellSideMAWP?.textBoxUnitValue && {
      shellSideMAWP_Measurement: fieldSourcePropertyWIthValue?.shellSideMAWP?.textBoxUnitValue
    }),
    ...(fieldSourcePropertyWIthValue?.shellSideMaxAWT?.textBoxValue && {
      shellSideMaxAWT: fieldSourcePropertyWIthValue?.shellSideMaxAWT?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.shellSideMaxAWT?.textBoxUnitValue && {
      shellSideMaxAWT_Measurement: fieldSourcePropertyWIthValue?.shellSideMaxAWT?.textBoxUnitValue
    }),
    ...(fieldSourcePropertyWIthValue?.shellSideMDMT?.textBoxValue && {
      shellSideMDMT: fieldSourcePropertyWIthValue?.shellSideMDMT?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.shellSideMDMT?.textBoxUnitValue && {
      shellSideMDMT_Measurement: fieldSourcePropertyWIthValue?.shellSideMDMT?.textBoxUnitValue
    }),
    ...(fieldSourcePropertyWIthValue?.shellThickness?.textBoxValue && {
      shellThickness: fieldSourcePropertyWIthValue?.shellThickness?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.shellThickness?.textBoxUnitValue && {
      shellThickness_Measurement: fieldSourcePropertyWIthValue?.shellThickness?.textBoxUnitValue
    }),
    ...(fieldSourcePropertyWIthValue?.tubeSideMAWP?.textBoxValue && {
      tubeSideMAWP: fieldSourcePropertyWIthValue?.tubeSideMAWP?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.tubeSideMAWP?.textBoxUnitValue && {
      tubeSideMAWP_Measurement: fieldSourcePropertyWIthValue?.tubeSideMAWP?.textBoxUnitValue
    }),
    ...(fieldSourcePropertyWIthValue?.tubeSideMDMT?.textBoxValue && {
      tubeSideMDMT: fieldSourcePropertyWIthValue?.tubeSideMDMT?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.tubeSideMDMT?.textBoxUnitValue && {
      tubeSideMDMT_Measurement: fieldSourcePropertyWIthValue?.tubeSideMDMT?.textBoxUnitValue
    }),

    //
    ...(fieldSourcePropertyWIthValue?.headTmin?.textBoxValue && {
      headTmin: fieldSourcePropertyWIthValue?.headTmin?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.headTmin?.textBoxUnitValue && {
      headTminUnit: fieldSourcePropertyWIthValue?.headTmin?.textBoxUnitValue
    }),

    ...(fieldSourcePropertyWIthValue?.shellTmin?.textBoxValue && {
      shellTmin: fieldSourcePropertyWIthValue?.shellTmin?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.shellTmin?.textBoxUnitValue && {
      shellTminUnit: fieldSourcePropertyWIthValue?.shellTmin?.textBoxUnitValue
    }),

    ...(fieldSourcePropertyWIthValue?.latitude && {
      latitude: fieldSourcePropertyWIthValue?.latitude
    }),

    ...(fieldSourcePropertyWIthValue?.longitude && {
      longitude: fieldSourcePropertyWIthValue?.longitude
    }),
    ...(fieldSourcePropertyWIthValue?.mainStationRegSerialNum && {
      mainStationRegSerialNum: fieldSourcePropertyWIthValue?.mainStationRegSerialNum
    }),

    ...(fieldSourcePropertyWIthValue?.capacity?.textBoxValue && {
      maximumCapacity: fieldSourcePropertyWIthValue?.capacity?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.capacity?.textBoxUnitValue && {
      capacityMeasurement: fieldSourcePropertyWIthValue?.capacity?.textBoxUnitValue
    }),

    ...(fieldSourcePropertyWIthValue?.volume?.textBoxValue && {
      volume: fieldSourcePropertyWIthValue?.volume?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.volume?.textBoxUnitValue && {
      volumeMeasurement: fieldSourcePropertyWIthValue?.volume?.textBoxUnitValue
    }),

    ...(fieldSourcePropertyWIthValue?.primaryRegSerialNum && {
      primaryRegSerialNum: fieldSourcePropertyWIthValue?.primaryRegSerialNum
    }),
    ...(fieldSourcePropertyWIthValue?.suppliedAirHarnessRegSerialNum && {
      suppliedAirHarnessRegSerialNum: fieldSourcePropertyWIthValue?.suppliedAirHarnessRegSerialNum
    }),

    ...(jurisdiction && { jurisdiction: jurisdiction }),
    ...(jurisdictionNumber && { jurisdictionNumber: jurisdictionNumber }),

    ...(fieldSourcePropertyWIthValue?.pWHT && {
      pwht: fieldSourcePropertyWIthValue?.pWHT
    }),

    ...(fieldSourcePropertyWIthValue?.maximum_Pressure?.textBoxValue && {
      maximum_Pressure: fieldSourcePropertyWIthValue?.maximum_Pressure?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.maximum_Pressure?.textBoxUnitValue && {
      maximum_Pressure_measurement: fieldSourcePropertyWIthValue?.maximum_Pressure?.textBoxUnitValue
    }),

    ...(fieldSourcePropertyWIthValue?.tubeSideMaxAWT?.textBoxValue && {
      TubeSideMaxAWT: fieldSourcePropertyWIthValue?.tubeSideMaxAWT?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.tubeSideMaxAWT?.textBoxUnitValue && {
      TubeSideMaxAWT_Measurement: fieldSourcePropertyWIthValue?.tubeSideMaxAWT?.textBoxUnitValue
    }),

    ...(fieldSourcePropertyWIthValue?.tankHeight?.textBoxValue && {
      Height: fieldSourcePropertyWIthValue?.tankHeight?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.tankHeight?.textBoxUnitValue && {
      Height_Measurement: fieldSourcePropertyWIthValue?.tankHeight?.textBoxUnitValue
    })
  };

  // ve_inspection;
  // tank_inspection;
  // vi_inspection
  // ut_inspection;
  // CurrentUserOrPlacement;
  // TargetAmpsText
  // Maximum_Pressure;
  // PWHT;
  // TankHeight;
  // UnitNumber;
  // UpperTargetAmpsText;
  //  "Structure - Name",
  // "Structure - Status",
  // Structure - Structure ID
  // Structure - Type;
  // TubeSideMaxAWT;

  return mapEquipmentObjects;
};

const getDataFromObjects = ({ data, equipmentFormsUserCacheMap }) => {
  let fieldSourcePropertyWIthValue = {};
  const moreFields = data?.moreFields || {};

  for (const key in moreFields) {
    const innerKey =
      moreFields[key] && Object.keys(moreFields[key]) && Object.keys(moreFields[key])[0];

    if (innerKey) {
      const value = moreFields[key][innerKey] || null;
      if (value) {
        if (equipmentFormsUserCacheMap[innerKey]) {
          let sourceProperty = equipmentFormsUserCacheMap[innerKey]?.sourceProperty || '';
          sourceProperty = sourceProperty.charAt(0).toLowerCase() + sourceProperty.slice(1);
          fieldSourcePropertyWIthValue = {
            ...fieldSourcePropertyWIthValue,
            [sourceProperty]: value
          };
        }
      }
    }
  }

  return fieldSourcePropertyWIthValue;
};

export const transformNewAndEditEquipmentDataForAutoPopulate = ({
  asset,
  equipmentFormsUserCacheMap,
  jurisdictionNumbersMap
}) => {
  const fieldSourcePropertyWIthValue = getDataFromObjects({
    data: asset,
    equipmentFormsUserCacheMap
  });
  const { jurisdictionNumber, jurisdiction } = jurisdictionNumbersMap[asset.equipmentId] || {};

  const mapEquipmentObjects = {
    ...(asset?.siteId && { siteId: asset?.siteId }),
    ...(asset?.name && { name: asset?.name }),
    ...(asset?.status && { status: asset?.status }),
    ...(asset?.equipmentCategory && { categoryId: asset?.equipmentCategory }),
    ...(asset?.equipmentType && { equipmentType: asset?.equipmentType }),
    ...(asset?.equipmentSubType && { equipmentSubType: asset?.equipmentSubType }),
    ...(asset?.description && { description: asset?.description }),
    ...(asset?.manufacturer && { manufacturer: asset?.manufacturer }),
    ...(asset?.model && { model: asset?.model }),
    ...(asset?.physicalLocation && { physicalLocation: asset?.physicalLocation }),
    ...(asset?.serialNumber && { serialNumber: asset?.serialNumber }),
    ...(asset?.fieldTagNumber && { fieldTagNumber: asset?.fieldTagNumber }),
    ...(asset?.manufacturedYear && { manufacturedYear: parseInt(asset?.manufacturedYear) }),
    ...(asset?.commentForReviewer && { comments: asset?.commentForReviewer }),
    ...(fieldSourcePropertyWIthValue?.flangeInletSize?.textBoxValue && {
      inletSize: fieldSourcePropertyWIthValue?.flangeInletSize?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.flangeInletSize?.textBoxUnitValue && {
      inletSizeMeasurement: fieldSourcePropertyWIthValue?.flangeInletSize?.textBoxUnitValue
    }),
    ...(fieldSourcePropertyWIthValue?.flangeOutletSize?.textBoxValue && {
      outletSize: fieldSourcePropertyWIthValue?.flangeOutletSize?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.flangeOutletSize?.textBoxUnitValue && {
      outletSizeMeasurement: fieldSourcePropertyWIthValue?.flangeOutletSize?.textBoxUnitValue
    }),
    ...(fieldSourcePropertyWIthValue?.cRN_Number && {
      crnNumber: fieldSourcePropertyWIthValue?.cRN_Number
    }),
    ...(fieldSourcePropertyWIthValue?.pressure?.textBoxValue && {
      pressure: fieldSourcePropertyWIthValue?.pressure?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.pressure?.textBoxUnitValue && {
      pressureUnit: fieldSourcePropertyWIthValue?.pressure?.textBoxUnitValue
    }),
    ...(fieldSourcePropertyWIthValue?.pSVCapacity?.textBoxValue && {
      psvCapacity: fieldSourcePropertyWIthValue?.pSVCapacity?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.pSVCapacity?.textBoxUnitValue && {
      psvCapacityUnit: fieldSourcePropertyWIthValue?.pSVCapacity?.textBoxUnitValue
    }),

    ...(fieldSourcePropertyWIthValue?.assessedCondition && {
      assessedCondition: fieldSourcePropertyWIthValue?.assessedCondition
    }),
    ...(fieldSourcePropertyWIthValue?.condition && {
      condition: fieldSourcePropertyWIthValue?.condition
    }),
    ...(fieldSourcePropertyWIthValue?.code_Of_Construction && {
      codeOfConstruction: fieldSourcePropertyWIthValue?.code_Of_Construction
    }),

    ...(fieldSourcePropertyWIthValue?.cylinderDate && {
      cylinderDate: fieldSourcePropertyWIthValue?.cylinderDate
    }),
    ...(fieldSourcePropertyWIthValue?.cylinderExpiryDate && {
      cylinderExpiryDate: fieldSourcePropertyWIthValue?.cylinderExpiryDate
    }),
    ...(fieldSourcePropertyWIthValue?.cylinderSerialNum && {
      cylinderSerialNum: fieldSourcePropertyWIthValue?.cylinderSerialNum
    }),

    ...(fieldSourcePropertyWIthValue?.cylinderType && {
      cylinderType: fieldSourcePropertyWIthValue?.cylinderType
    }),

    ...(fieldSourcePropertyWIthValue?.diameter?.textBoxValue && {
      diameter: fieldSourcePropertyWIthValue?.diameter?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.diameter?.textBoxUnitValue && {
      diameterMeasurement: fieldSourcePropertyWIthValue?.diameter?.textBoxUnitValue
    }),

    ...(fieldSourcePropertyWIthValue?.gearboxManufacturer && {
      gearboxManufacturer: fieldSourcePropertyWIthValue?.gearboxManufacturer
    }),

    ...(fieldSourcePropertyWIthValue?.gearboxRate && {
      gearboxRate: fieldSourcePropertyWIthValue?.gearboxRate
    }),

    ...(fieldSourcePropertyWIthValue?.gearboxSerialNumber && {
      gearboxSerialNumber: fieldSourcePropertyWIthValue?.gearboxSerialNumber
    }),

    ...(fieldSourcePropertyWIthValue?.head2Thickness?.textBoxValue && {
      head2Thickness: fieldSourcePropertyWIthValue?.head2Thickness?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.head2Thickness?.textBoxUnitValue && {
      head2Thickness_Measurement: fieldSourcePropertyWIthValue?.head2Thickness?.textBoxUnitValue
    }),

    ...(fieldSourcePropertyWIthValue?.headMaterialId && {
      headMaterialId: fieldSourcePropertyWIthValue?.headMaterialId
    }),

    ...(fieldSourcePropertyWIthValue?.headThickness?.textBoxValue && {
      headThickness: fieldSourcePropertyWIthValue?.headThickness?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.headThickness?.textBoxUnitValue && {
      headThickness_Measurement: fieldSourcePropertyWIthValue?.headThickness?.textBoxUnitValue
    }),

    ...(fieldSourcePropertyWIthValue?.hydrotestExpiryDate5Year && {
      hydrotestExpiryDate5Year: fieldSourcePropertyWIthValue?.hydrotestExpiryDate5Year
    }),

    ...(fieldSourcePropertyWIthValue?.insulationMaterialId && {
      insulationMaterialId: fieldSourcePropertyWIthValue?.insulationMaterialId
    }),

    ...(fieldSourcePropertyWIthValue?.lastMainStationRegInspDate && {
      lastMainStationRegInspDate: fieldSourcePropertyWIthValue?.lastMainStationRegInspDate
    }),
    ...(fieldSourcePropertyWIthValue?.lastSuppliedAirHarnessRegInspDate && {
      lastSuppliedAirHarnessRegInspDate:
        fieldSourcePropertyWIthValue?.lastSuppliedAirHarnessRegInspDate
    }),

    ...(fieldSourcePropertyWIthValue?.length?.textBoxValue && {
      length: fieldSourcePropertyWIthValue?.length?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.length?.textBoxUnitValue && {
      lengthMeasurement: fieldSourcePropertyWIthValue?.length?.textBoxUnitValue
    }),

    ...(fieldSourcePropertyWIthValue?.mAWP?.textBoxValue && {
      mawp: fieldSourcePropertyWIthValue?.mAWP?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.mAWP?.textBoxUnitValue && {
      mawpMeasurement: fieldSourcePropertyWIthValue?.mAWP?.textBoxUnitValue
    }),

    ...(fieldSourcePropertyWIthValue?.mAWT?.textBoxValue && {
      mawt: fieldSourcePropertyWIthValue?.mAWT?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.mAWT?.textBoxUnitValue && {
      mawtMeasurement: fieldSourcePropertyWIthValue?.mAWT?.textBoxUnitValue
    }),

    ...(fieldSourcePropertyWIthValue?.mDMT?.textBoxValue && {
      mdmt: fieldSourcePropertyWIthValue?.mDMT?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.mDMT?.textBoxUnitValue && {
      mdmtMeasurement: fieldSourcePropertyWIthValue?.mDMT?.textBoxUnitValue
    }),

    ...(fieldSourcePropertyWIthValue?.orientation && {
      orientation: fieldSourcePropertyWIthValue?.orientation
    }),

    ...(fieldSourcePropertyWIthValue?.outsideDiameter?.textBoxValue && {
      outsideDiameter: fieldSourcePropertyWIthValue?.outsideDiameter?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.outsideDiameter?.textBoxUnitValue && {
      outsideDiameter_Measurement: fieldSourcePropertyWIthValue?.outsideDiameter?.textBoxUnitValue
    }),

    ...(fieldSourcePropertyWIthValue?.plateNumber && {
      plateNumber: parseInt(fieldSourcePropertyWIthValue?.plateNumber)
    }),

    ...(fieldSourcePropertyWIthValue?.pSVCapacity?.textBoxUnitValue && {
      psvCapacityMeasurement: fieldSourcePropertyWIthValue?.pSVCapacity?.textBoxUnitValue
    }),

    ...(fieldSourcePropertyWIthValue?.service && {
      service: fieldSourcePropertyWIthValue?.service
    }),

    ...(fieldSourcePropertyWIthValue?.setPointPressure?.textBoxValue && {
      setPointPressure: fieldSourcePropertyWIthValue?.setPointPressure?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.setPointPressure?.textBoxUnitValue && {
      setPointPressureMeasurement: fieldSourcePropertyWIthValue?.setPointPressure?.textBoxUnitValue
    }),

    ...(fieldSourcePropertyWIthValue?.shellMaterialId && {
      shellMaterialId: fieldSourcePropertyWIthValue?.shellMaterialId
    }),
    ...(asset?.manufacturedYear && { yearBuilt: parseInt(asset?.manufacturedYear) }),
    ...(fieldSourcePropertyWIthValue?.shellSideMAWP?.textBoxValue && {
      shellSideMAWP: fieldSourcePropertyWIthValue?.shellSideMAWP?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.shellSideMAWP?.textBoxUnitValue && {
      shellSideMAWPMeasurement: fieldSourcePropertyWIthValue?.shellSideMAWP?.textBoxUnitValue
    }),
    ...(fieldSourcePropertyWIthValue?.shellSideMaxAWT?.textBoxValue && {
      shellSideMaxAWT: fieldSourcePropertyWIthValue?.shellSideMaxAWT?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.shellSideMaxAWT?.textBoxUnitValue && {
      shellSideMaxAWTMeasurement: fieldSourcePropertyWIthValue?.shellSideMaxAWT?.textBoxUnitValue
    }),
    ...(fieldSourcePropertyWIthValue?.shellSideMDMT?.textBoxValue && {
      shellSideMDMT: fieldSourcePropertyWIthValue?.shellSideMDMT?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.shellSideMDMT?.textBoxUnitValue && {
      shellSideMDMTMeasurement: fieldSourcePropertyWIthValue?.shellSideMDMT?.textBoxUnitValue
    }),
    ...(fieldSourcePropertyWIthValue?.shellThickness?.textBoxValue && {
      shellThickness: fieldSourcePropertyWIthValue?.shellThickness?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.shellThickness?.textBoxUnitValue && {
      shellThicknessMeasurement: fieldSourcePropertyWIthValue?.shellThickness?.textBoxUnitValue
    }),
    ...(fieldSourcePropertyWIthValue?.tubeSideMAWP?.textBoxValue && {
      tubeSideMAWP: fieldSourcePropertyWIthValue?.tubeSideMAWP?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.tubeSideMAWP?.textBoxUnitValue && {
      tubeSideMAWPMeasurement: fieldSourcePropertyWIthValue?.tubeSideMAWP?.textBoxUnitValue
    }),
    ...(fieldSourcePropertyWIthValue?.tubeSideMDMT?.textBoxValue && {
      tubeSideMDMT: fieldSourcePropertyWIthValue?.tubeSideMDMT?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.tubeSideMDMT?.textBoxUnitValue && {
      tubeSideMDMTMeasurement: fieldSourcePropertyWIthValue?.tubeSideMDMT?.textBoxUnitValue
    }),

    //
    ...(fieldSourcePropertyWIthValue?.headTmin?.textBoxValue && {
      headTmin: fieldSourcePropertyWIthValue?.headTmin?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.headTmin?.textBoxUnitValue && {
      headTminUnit: fieldSourcePropertyWIthValue?.headTmin?.textBoxUnitValue
    }),

    ...(fieldSourcePropertyWIthValue?.shellTmin?.textBoxValue && {
      shellTmin: fieldSourcePropertyWIthValue?.shellTmin?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.shellTmin?.textBoxUnitValue && {
      shellTminUnit: fieldSourcePropertyWIthValue?.shellTmin?.textBoxUnitValue
    }),

    ...(fieldSourcePropertyWIthValue?.latitude && {
      latitude: fieldSourcePropertyWIthValue?.latitude
    }),

    ...(fieldSourcePropertyWIthValue?.longitude && {
      longitude: fieldSourcePropertyWIthValue?.longitude
    }),
    ...(fieldSourcePropertyWIthValue?.mainStationRegSerialNum && {
      mainStationRegSerialNum: fieldSourcePropertyWIthValue?.mainStationRegSerialNum
    }),

    ...(fieldSourcePropertyWIthValue?.capacity?.textBoxValue && {
      maximumCapacity: fieldSourcePropertyWIthValue?.capacity?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.capacity?.textBoxUnitValue && {
      capacityMeasurement: fieldSourcePropertyWIthValue?.capacity?.textBoxUnitValue
    }),

    ...(fieldSourcePropertyWIthValue?.volume?.textBoxValue && {
      volume: fieldSourcePropertyWIthValue?.volume?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.volume?.textBoxUnitValue && {
      volumeMeasurement: fieldSourcePropertyWIthValue?.volume?.textBoxUnitValue
    }),

    ...(fieldSourcePropertyWIthValue?.primaryRegSerialNum && {
      primaryRegSerialNum: fieldSourcePropertyWIthValue?.primaryRegSerialNum
    }),
    ...(fieldSourcePropertyWIthValue?.suppliedAirHarnessRegSerialNum && {
      suppliedAirHarnessRegSerialNum: fieldSourcePropertyWIthValue?.suppliedAirHarnessRegSerialNum
    }),

    ...(jurisdiction && { jurisdiction: jurisdiction }),
    ...(jurisdictionNumber && { jurisdictionNumber: jurisdictionNumber }),

    ...(fieldSourcePropertyWIthValue?.pWHT && {
      pwht: fieldSourcePropertyWIthValue?.pWHT
    }),

    ...(fieldSourcePropertyWIthValue?.maximum_Pressure?.textBoxValue && {
      maximumPressure: fieldSourcePropertyWIthValue?.maximum_Pressure?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.maximum_Pressure?.textBoxUnitValue && {
      maximumPressureMeasurement: fieldSourcePropertyWIthValue?.maximum_Pressure?.textBoxUnitValue
    }),

    ...(fieldSourcePropertyWIthValue?.tubeSideMaxAWT?.textBoxValue && {
      tubeSideMaxAWT: fieldSourcePropertyWIthValue?.tubeSideMaxAWT?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.tubeSideMaxAWT?.textBoxUnitValue && {
      tubeSideMaxAWTMeasurement: fieldSourcePropertyWIthValue?.tubeSideMaxAWT?.textBoxUnitValue
    }),

    ...(fieldSourcePropertyWIthValue?.tankHeight?.textBoxValue && {
      height: fieldSourcePropertyWIthValue?.tankHeight?.textBoxValue
    }),
    ...(fieldSourcePropertyWIthValue?.tankHeight?.textBoxUnitValue && {
      eightMeasurement: fieldSourcePropertyWIthValue?.tankHeight?.textBoxUnitValue
    })
  };

  return mapEquipmentObjects;
};

//   "location": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
//   "mobileFormType": "string",
//   "flangeInletJointStyle": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
//   "flangeOutletJointStyle": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
//   "pvId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
//   "isDetached": true
